export default {"src":"/login-app/[GIT_HASH]/_next/static/media/arrow_back.737a58dd.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};